import { UNIT_SYSTEM } from "constants/units.contants";
import { uiGroupToCloGroup } from "./mappers";
import app from "./reducers/app";
import packingList from "./reducers/packingList";
import root, { setErrorProduct, setOptions, setProduct } from "./reducers/root";

import { combineReducers, configureStore, Middleware } from "@reduxjs/toolkit";

const reducer = combineReducers({
  root,
  packingList,
  app,
});

export type RootState = ReturnType<typeof reducer>;

const syncPackingListToRoot: Middleware<object, RootState> = (api) => (next) => (action) => {
  const result = next(action);

  if (typeof action !== "object" || action == null || !("type" in action)) {
    return result;
  }

  const type = String((action as { type: string }).type);

  if (type.startsWith("packingList/")) {
    try {
      const uiGroups = api.getState().packingList.groups;
      const existingColors = new Map<string, string>(
        api.getState().root.groups.map((g) => [String(g.uid), String(g.color ?? "#000")])
      );
      api.dispatch(
        setProduct(uiGroups.map((group) => uiGroupToCloGroup(group, existingColors.get(group.id) ?? "#000")))
      );
    } catch {}

    if (api.getState().root.errorProducts.length > 0) {
      api.dispatch(setErrorProduct([]));
    }
  }

  if (type === "app/setUnitSystem") {
    const unit = api.getState().app.unitSystem;
    const options = api.getState().root.options;
    api.dispatch(
      setOptions({
        ...options,
        lengthUnits: unit === UNIT_SYSTEM.IMPERIAL ? "inch" : "mm",
        weightUnits: unit === UNIT_SYSTEM.IMPERIAL ? "lb" : "kg",
      })
    );
  }

  return result;
};

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
      actionCreatorCheck: false,
    }).concat(syncPackingListToRoot),
  devTools: __DEV__,
});

export type AppDispatch = typeof store.dispatch;

store.dispatch(setProduct(store.getState().packingList.groups.map((group) => uiGroupToCloGroup(group))));

export * from "./reducers/app";
export * from "./reducers/packingList";
export * from "./reducers/root";

export default store;
